// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/drawer/style/index.less
// module id = 88
// module chunks = 0